import authStorage from "../storage/auth.storage";
import NetworkService from "./base.network";

class AuthNetworkService extends NetworkService {
  onLogout(): void {
    authStorage.removeToken();
  }
}

export const authNetwork = new AuthNetworkService();

export default authNetwork;
